<script lang="ts">
	//Services
	import { format } from '../../../../services/i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';

	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	import { capFirstChar } from '../../../../helpers/utilities';
	import { rebootDevice } from '../../../../helpers/device_settings_helpers';

	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';

	//Design system components
	import { Alert, Toggle, toast } from '@Shelly/shelly-design-system';

	import ModalPrompt from '../../../../components/ModalPrompt.svelte';

	export let device;

	const id = real_id(device.id);

	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;

	let enabled = settings?.sys?.device?.eco_mode,
		cacheEnabled = enabled,
		showModal = false;

	const handleSave = async () => {
		const newEnabled = !enabled;

		if (cacheEnabled !== newEnabled) {
			const data = { config: { device: { eco_mode: newEnabled } } },
				eco_mode_state = newEnabled
					? $format('eco_mode_enabled_scc_toast')
					: $format('eco_mode_disabled_scc_toast');

			const res: SettingRequest = await gen2Request(device, 'sys.setconfig', data);

			if (res.isok) {
				enabled = newEnabled;
				settings.sys.device.eco_mode = enabled;
				devices_settings.update_devices_settings(id, settings);
				if (res?.data?.restart_required) {
					showModal = true;
				} else {
					toast.open({ type: 'success', title: eco_mode_state }); //Here toast overlaps modal prompt on mobile so maybe it is good idea to visualize only if no reboot required
				}
				cacheEnabled = enabled;
			} else {
				enabled = cacheEnabled;
				toast.open({ type: 'danger', title: $format('error_global') });
			}
		}
	};
	const _rebootDevice = async () => {
		rebootDevice(device, true);
		// const res: SettingRequest = await gen2Request(device, 'shelly.reboot', {});
		// rebooting_devices.update(device.id);
		// onSettingsResponse(res, device, {
		// 	success: $format('reboot_scc_toast'),
		// 	danger: $format('reboot_err_toast')
		// });
	};
</script>

<Toggle
	checked={enabled}
	class="mb-s"
	size="m"
	on:click={handleSave}
	info={$showNewLayout
		? $format('eco_mode_description', {
				default:
					'Device will consume less energy and run at lower temperature. Device will reboot if you Disable/Enable it.',
			})
		: undefined}
	id="toggle-q7k4z3l"
>
	{$showNewLayout
		? $format('sub_settings_title_eco_mode', {
				default: 'Eco mode',
			})
		: $format('enable', {
				default: 'Enable',
			})}
</Toggle>

{#if !$showNewLayout}
	<Alert
		heading={$format('eco_mode_description', {
			default:
				'Device will consume less energy and run at lower temperature. Device will reboot if you Disable/Enable it.',
		})}
	/>
{/if}

{#if showModal}
	<ModalPrompt
		props={{
			title: capFirstChar($format('sub_settings_title_device_reboot')),
			text: $format('reboot_description'),
			button_1: $format('button_reboot'),
			button_2: $format('button_cancel'),
			callback: _rebootDevice,
		}}
	/>
{/if}
